<template>
  <section class="container-fluid my-4 col-md-10 offset-md-2">
    <h4 class="my-4">Editar <strong>Tarefa</strong></h4>

    <form @submit.prevent="handlerSubmit">
      <div class="row">
        <div class="form-group col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="item.name" required />
        </div>

        <div class="form-group col-md-12 mt-2">
          <label>Descrição</label>
          <textarea class="form-control" rows="3" v-model="item.description"></textarea>
        </div>

        <div class="form-group col-md-12 mt-2">
          <label>Tipo de Tarefa</label>
          <select class="form-control" v-model="item.task_type_id">
            <option :value="null">Nenhum</option>
            <option v-for="type in taskTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
          </select>
        </div>
      </div>

      <div class="form-group text-center my-2">
        <button type="submit" class="btn btn-success btn-sm mx-2">SALVAR</button>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">VOLTAR</button>
  </section>
</template>

<script>
import api from "@/services";
import { errorsToString } from "@/helpers";

export default {
  name: "TaskEdit",
  props: ["id"],
  data() {
    return {
      item: {},
      taskTypes: [],
    };
  },
  methods: {
    async handlerSubmit() {
      try {
        const { data } = await api.put(`/tasks/${this.id}`, this.item);
        Toast.fire(data.message, "", "success");
        this.$router.push({ name: "tasks" });
      } catch (error) {
        Toast.fire(errorsToString(error.response.data.errors), "", "error");
      }
    },
    async loadItem() {
      const { data } = await api.get(`/tasks/${this.id}`);
      this.item = data;
    },
    async loadTaskTypes() {
      const { data } = await api.get("/task-types?perPage=100");
      this.taskTypes = data.data;
    },
  },
  async mounted() {
    await Promise.all([this.loadItem(), this.loadTaskTypes()]);
  },
};
</script>
